<template>
  <div class="user">
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" href="#">
           <span>
             {{userName}}
             <b class="caret"></b>
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <slot>
              <!-- <li>
                <a class="profile-dropdown" href="#">
                  <span class="sidebar-mini"><i class="fas fa-user mt-1"/></span>
                  <span class="sidebar-normal">My Profile</span>
                </a>
              </li> -->
              <li>
                <a class="profile-dropdown" href="#" @click="logout()">
                  <span class="sidebar-mini"><i class="far fa-power-off mt-1"/></span>
                  <span class="sidebar-normal">Logout</span>
                </a>
              </li>
              <li>
                <a class="profile-dropdown">
                  <span class="side-normal small mt-4">
                    accountId: {{$store.getters.user.accountId}}
                  </span>
                </a>
              </li>
            </slot>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    props: {/* 
      title: {
        type: String,
        default: 'Guillaume L\'Herbette'
      } */
    },
    data () {
      return {
        isClosed: true
      }
    },
    computed: {
      userName () { return this.$store.getters.user ? `${this.$store.getters.user.firstName} ${this.$store.getters.user.lastName}` : '' }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      },
      logout () {
        this.$store.dispatch('logout')
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>
